import React, { useEffect } from 'react';
import { StatusManager } from 'common/components/StatusManager';
import strings from 'strings';
import { When } from 'UI/components/atoms';
import FPActionButton from 'UI/components/atoms/FPActionButton';
import FPButtonBuilder from 'UI/components/molecules/FPButtonBuilder';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';
import { UIStatus } from 'UI/constants/status';
import { SvgNoJobOrders } from 'UI/res';

import useAssignmentSheet from './hooks/useAssignmentSheet';
import { StyledGpacGeneratorForm, useDataSheetDrawerStyles } from './AssignmentSheetDrawer.styled';

export const AssignmentSheetDrawer = props => {
  const {
    assignmentSheetId,
    drawerTitle,
    whiteSheet,
    companyId,
    onClose,
    onSaveAssignmentSheet,
    onRegisterSaveFlush
  } = props;
  const classes = useDataSheetDrawerStyles();
  const [dataSheetState, dataSheetActions] = useAssignmentSheet({
    assignmentSheetId,
    whiteSheet,
    companyId,
    onSaveAssignmentSheet,
    onClose
  });

  useEffect(() => {
    onRegisterSaveFlush?.(dataSheetActions.flushPendingSave);
  }, [dataSheetActions.flushPendingSave, onRegisterSaveFlush]);

  const getStatus = () => {
    if (dataSheetState.wasThereAnError) {
      return UIStatus.Error;
    }

    if (dataSheetState.isFetching || dataSheetState.isFetchingAssignmentSheetData) {
      return UIStatus.Loading;
    }

    return UIStatus.Success;
  };

  const buttonDefinitions = [
    {
      props: {
        text: strings.shared.ui.close,
        variant: 'outlined',
        onClick: onClose
      }
    },
    {
      props: {
        initialText: dataSheetState.primaryButtonName,
        variant: 'contained',
        onClick: dataSheetActions.onSaveClick,
        onProgressText: strings.shared.ui.saving,
        isSaving: dataSheetState.isSaving,
        disabled: dataSheetState.isSaving || dataSheetState.wasThereAnError
      },
      mode: 'save'
    }
  ];

  return (
    <FPDrawer
      CardHeaderProps={{ title: drawerTitle }}
      onClose={onClose}
      FPDrawerProps={{ open: true, classes: { paper: classes.drawerLarge } }}
      hasPaddingContent={false}
      contentContainerClassName={classes.drawerContent}
      footer={
        <FPButtonBuilder
          GridContainerProps={{ spacing: 2 }}
          buttonDefinitions={buttonDefinitions}
        />
      }
    >
      <StatusManager
        status={getStatus()}
        slots={{
          Error: (
            <EmptyPlaceholder
              {...strings.shared.errors.serverError}
              customEmptyState={<SvgNoJobOrders height={400} />}
            >
              <FPActionButton text="Try again" onClick={() => window.location.reload()} />
            </EmptyPlaceholder>
          )
        }}
      >
        <When condition={!!dataSheetState.data}>
          {() => (
            <StyledGpacGeneratorForm
              schema={dataSheetState.data.structure}
              uiSchema={dataSheetState.data.ui}
              httpOptions={dataSheetState.httpOptions}
              showErrorList={false}
              formData={dataSheetState.formData}
              onSubmit={dataSheetActions.save}
              onChange={dataSheetActions.handleOnChange}
              submitRef={dataSheetState.saveButtonRef}
              baseUrl={dataSheetState.baseUrl}
              noHtml5Validate
              focusOnFirstError
            />
          )}
        </When>
      </StatusManager>
    </FPDrawer>
  );
};
